import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'

import BkFlowRoomCardDescriptionAccordion from '../elements/BkFlowRoomCardDescriptionAccordion'
import BkFlowRoomCardAdaDescription from '../elements/accessiblity/BkFlowRoomCardAdaDescription'
import BkFlowFeaturedIcons from '../elements/icons/BkFlowRoomFeaturedIcons'
import BkFlowRoomCardDescriptionButtons from '../elements/BkFlowRoomCardDescriptionButtons'
import BkFlowRoomCardDefaultRateToggle from '../elements/default/configured/BkFlowRoomCardDefaultRateToggle'
import BkFlowRoomCardMediaGallery from '../elements/gallery/BkFlowRoomCardMediaGallery'
import BkFlowRoomCardConfiguredRates from '../elements/default/configured/BkFlowRoomCardConfiguredRates'
import BkFlowRoomCardDynamicRatesToggle from '../elements/default/dynamic/BkFlowRoomCardDynamicRatesToggle'

import _ from 'lodash'
import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default') {
	require('../../../styles/css/components/room/bk-flow-room-cards-default.css')
}

const BkFlowRoomCardDefault = props => {
	const {
		activeCurrencyData,
		activeRoomsAmount,
		adaDescriptionEvent,
		adaDescriptionExpanded,
		cards,
		configData,
		currentRateCode,
		currentRoomType,
		currentUpSells,
		displayedPriceFrequency,
		fullScreenEvent,
		gallery,
		hasValidSpecialPackages,
		hotelLabels,
		imageClickEvent,
		isFullScreen,
		isTaxInclusiveProperty,
		multiRoomData,
		notificationCloseEvent,
		payFeaturedRoomRates,
		payLaterRatePlan,
		payLaterRoomRate,
		payNowRatePlan,
		payNowRoomRate,
		payPromoRoomRates,
		quantityNotifications,
		queriedRatePlan,
		queriedRoomRate,
		renderFullScreenButton,
		roomDescriptionEvent,
		roomDescriptionExpanded,
		roomDetailsAccordionEvent,
		roomDetailsAccordionExpanded,
		roomGroup,
		roomRateStageEvent,
		setSelectedRoom,
		showNotification,
		specialPackagesAccordionEvent,
		specialPackagesExpanded,
		toggleActiveRoom,
		totalNights,
		totalRoomRates,
		unrefinedGuestRoom,
		unrefinedRoomDescription,
		upSellsToggleEvent,
		urlData,
		virtualTourEvent,
	} = props

	let renderFeaturedRateToggles = [],
			renderPromoRateToggles = []

	if (!_.isEmpty(payFeaturedRoomRates)) {
		for (const rateKey in payFeaturedRoomRates) {
			const currentFeaturedRate = payFeaturedRoomRates[rateKey]

			if (
				currentFeaturedRate.roomRateData &&
				currentFeaturedRate.ratePlanData
			) {
				renderFeaturedRateToggles.push(
					<BkFlowRoomCardDefaultRateToggle
						activeCurrencyData={ activeCurrencyData }
						currentRateCode={ currentRateCode }
						displayedPriceFrequency={displayedPriceFrequency}
						hotelLabels={ hotelLabels }
						key={'featured-room-rate-' + rateKey}
						ratePlanData={ currentFeaturedRate.ratePlanData }
						roomGroup={ roomGroup }
						roomRateData={ currentFeaturedRate.roomRateData }
						roomTypeData={cards}
						setSelectedRoom={ setSelectedRoom }
						totalNights={ totalNights }
					/>
				)
			}
		}
	}

	if (
		urlData &&
		urlData.promoCode &&
		!_.isEmpty(payPromoRoomRates)
	) {
		for (const rateKey in payPromoRoomRates) {
			const currentPromoRate = payPromoRoomRates[rateKey]

			if (
				currentPromoRate.roomRateData &&
				currentPromoRate.ratePlanData
			) {
				renderPromoRateToggles.push(
					<BkFlowRoomCardDefaultRateToggle
						activeCurrencyData={ activeCurrencyData }
						currentRateCode={ currentRateCode }
						displayedPriceFrequency={displayedPriceFrequency}
						genericRateLabel={ hotelLabels.payPromo ? hotelLabels.payPromo : 'Promo Offer' }
						hotelLabels={ hotelLabels }
						key={'promo-room-rate-' + rateKey}
						ratePlanData={ currentPromoRate.ratePlanData }
						roomGroup={ roomGroup }
						roomRateData={ currentPromoRate.roomRateData }
						roomTypeData={cards}
						setSelectedRoom={ setSelectedRoom }
						totalNights={ totalNights }
					/>
				)
			}
		}
	}

	return (
		<div
			id={ 'bk-flow-room__' + cards.roomTypeCode }
			key={ cards.roomTypeCode }
			className="bk-flow-room__card-entry row u-remove-padding"
		>
			<BkFlowRoomCardMediaGallery
				cards={cards}
				enableBullets={false}
				fullScreenEvent={fullScreenEvent}
				gallery={gallery}
				hotelLabels={hotelLabels}
				imageClickEvent={imageClickEvent}
				isFullScreen={isFullScreen}
				quantityNotifications={quantityNotifications}
				renderFullScreenButton={renderFullScreenButton}
				totalRoomRates={totalRoomRates}
				virtualTourEvent={virtualTourEvent}
			/>

			<div className="bk-flow-room__card-description">

				<div className="bk-flow-room__card-description__copy row">
					{ yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA)
						&& !_.isEmpty(unrefinedGuestRoom) ?
						<h3>{ unrefinedGuestRoom[0].RoomTypeName }</h3>
					: cards.roomDescription.name ? (
						<h3>{ cards.roomDescription.name }</h3>
					) : (
						null
					)}

					{ yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
						!_.isEmpty(unrefinedGuestRoom) &&
						!_.isEmpty(unrefinedRoomDescription) ?
						<BkFlowRoomCardDescriptionAccordion
							hotelLabels={ hotelLabels }
							roomDescription={ unrefinedRoomDescription[0]['en-US'] }
							roomDescriptionExpanded={ roomDescriptionExpanded }
							roomData={ cards }
							limitChars={ 160 }
							roomDescriptionEvent={ () => roomDescriptionEvent() }
						/>
					: cards.roomDescription &&
						cards.roomDescription.text ?
						<BkFlowRoomCardDescriptionAccordion
							hotelLabels={ hotelLabels }
							roomDescription={ cards.roomDescription.text }
							roomDescriptionExpanded={ roomDescriptionExpanded }
							roomData={ cards }
							limitChars={ 160 }
							roomDescriptionEvent={ () => roomDescriptionEvent() }
						/>
					:
						null
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_FEATURED_ICONS) && <BkFlowFeaturedIcons roomGroup={ roomGroup } roomData={ cards } /> }

					{ !yn(process.env.REACT_APP_COMPONENT_ROOM_FEATURED_ICONS) &&
						cards.viewExtensions &&
						cards.viewExtensions.adaDetails &&
							<BkFlowRoomCardAdaDescription
								adaDisclaimer={ cards.viewExtensions.adaDetails }
								hotelLabels={hotelLabels}
								toggledState={ adaDescriptionExpanded}
								toggleEvent={ adaDescriptionEvent}
							/>
					}
				</div>

				{ yn(process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES) ||
					yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION) ?
					<BkFlowRoomCardDescriptionButtons
						hotelLabels={ hotelLabels }
						isMobileButtons={ false }
						hasValidSpecialPackages={ hasValidSpecialPackages }
						specialPackagesExpanded={ specialPackagesExpanded }
						roomDetailsExpanded={ roomDetailsAccordionExpanded }
						handleSpecialPackagesAccordion={ specialPackagesAccordionEvent }
						handleRoomDetailsAccordion={ roomDetailsAccordionEvent }
					/>
				:
					null
				}
			</div>

			<div className="bk-flow-room__card-data row center-xs start-lg">
				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING) ?
					<BkFlowRoomCardConfiguredRates
						activeCurrencyData={activeCurrencyData}
						activeRoomsAmount={activeRoomsAmount}
						cards={cards}
						configData={configData}
						currentRateCode={currentRateCode}
						currentRoomType={currentRoomType}
						currentUpSells={currentUpSells}
						displayedPriceFrequency={displayedPriceFrequency}
						hotelLabels={hotelLabels}
						multiRoomData={multiRoomData}
						payLaterRatePlan={payLaterRatePlan}
						payLaterRoomRate={payLaterRoomRate}
						payNowRatePlan={payNowRatePlan}
						payNowRoomRate={payNowRoomRate}
						queriedRatePlan={queriedRatePlan}
						queriedRoomRate={queriedRoomRate}
						renderFeaturedRateToggles={renderFeaturedRateToggles}
						renderPromoRateToggles={renderPromoRateToggles}
						roomGroup={roomGroup}
						setSelectedRoom={setSelectedRoom}
						toggleActiveRoom={toggleActiveRoom}
						totalNights={totalNights}
						upSellsToggleEvent={upSellsToggleEvent}
						urlData={urlData}
					/>
				:
					<BkFlowRoomCardDynamicRatesToggle
						activeCurrencyData={activeCurrencyData}
						cards={cards}
						configData={configData}
						displayedPriceFrequency={displayedPriceFrequency}
						hotelLabels={hotelLabels}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						roomRateStageEvent={roomRateStageEvent}
						totalNights={totalNights}
						urlData={urlData}
					/>
				}

				{ yn(process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES) ||
					yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION) ?
					<BkFlowRoomCardDescriptionButtons
						hotelLabels={ hotelLabels }
						isMobileButtons={ true }
						hasValidSpecialPackages={ hasValidSpecialPackages }
						specialPackagesExpanded={ specialPackagesExpanded }
						roomDetailsExpanded={ roomDetailsAccordionExpanded }
						handleSpecialPackagesAccordion={ specialPackagesAccordionEvent }
						handleRoomDetailsAccordion={ roomDetailsAccordionEvent }
					/>
				:
					null
				}

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					open={ showNotification }
					autoHideDuration={ 2000 }
					onClose={ notificationCloseEvent }
					message={ <span id="bk-flow-notification__data">{ cards.roomDescription && cards.roomDescription.name && cards.roomDescription.name } { hotelLabels.selected }</span> }
					action={ [<button key="hideUpdate" className="bk-flow-notification__close u-remove-padding u-color-white u-font-medium" onClick={ () => notificationCloseEvent() }>{ hotelLabels.close } &times;</button>] }
				/>
			</div>
		</div>
	)
}

export default BkFlowRoomCardDefault


// WEBPACK FOOTER //
// ./src/components/room/layouts/BkFlowRoomCardDefault.js